<template>
  <div class="space-y-4">
    <base-card
      title="Tambah Koli"
      description="Tambahkan barang yang akan dikemas"
    >
      <div class="space-y-4">
        <div
          v-for="(packet, packetIndex) in packets"
          :key="packetIndex"
          class="space-y-4 rounded-lg border border-gray-200 bg-white p-6"
        >
          <div class="item-stretch flex gap-4">
            <base-input
              fullwidth
              inset
              label="Nama Koli"
              type="text"
              v-model="packets[packetIndex].name"
            />
            <base-button
              :disabled="packets.length < 2"
              custom-height="h-auto"
              :self-end="false"
              :color="packets.length > 1 ? 'danger-secondary' : 'gray'"
              @click="onRemovePacket(packetIndex)"
            >
              <Icon icon="heroicons:trash-solid" class="h-4 w-4" />
              Hapus Koli
            </base-button>
          </div>

          <datatable
            :columns="[
              {
                code: 'kode barang',
                name: 'Kode Barang',
              },
              {
                code: 'nama barang',
                name: 'Nama Barang',
              },
              {
                code: 'jumlah',
                name: 'Jumlah',
              },
              {
                code: 'batch',
                name: 'Batch',
              },
              {
                code: 'aksi',
                name: 'Aksi',
                theadClass: 'text-center',
              },
            ]"
          >
            <template #tbody="{ classes }">
              <template v-if="!packet.products.length">
                <tr :class="classes.tr">
                  <td colspan="5" :class="classes.td">
                    <button
                      class="flex w-full flex-col items-center space-y-2 py-4 text-center text-gray-400 hover:text-gray-500"
                      @click="onAddPacketProduct(packetIndex)"
                    >
                      <Icon icon="heroicons:plus-circle" class="h-6 w-6" />
                      <p class="text-xs font-normal">
                        Tidak ada data<br />Klik untuk menambahkan
                      </p>
                    </button>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr
                  v-for="(product, index) in packet.products.filter(
                    (product) => product.qty > 0
                  )"
                  :key="index"
                  :class="classes.tr"
                >
                  <td :class="classes.td">
                    <p class="font-bold text-gray-900">
                      {{
                        getProductDetail(product.orderDetailOrBonusId)
                          .attributes.product_code
                      }}
                      <span
                        v-if="
                          getProductDetail(product.orderDetailOrBonusId)
                            .type === 'order-detail-bonuses'
                        "
                        >(FREE)</span
                      >
                    </p>
                  </td>
                  <td :class="classes.td">
                    {{
                      getProductDetail(product.orderDetailOrBonusId).attributes
                        .product_name
                    }}
                  </td>
                  <td :class="classes.td">
                    {{ product.qty }}
                  </td>
                  <td :class="classes.td">
                    {{ product.batches.length }}
                  </td>
                  <td :class="[classes.td, 'text-center']">
                    <button @click="onRemovePacketProduct(packetIndex, index)">
                      <Icon
                        icon="heroicons:trash-solid"
                        class="h-4 w-4 text-red-500"
                      />
                    </button>
                  </td>
                </tr>
              </template>
            </template>
          </datatable>

          <div v-if="packet.products.length" class="flex justify-end">
            <base-button
              size="sm"
              color="white"
              @click="onAddPacketProduct(packetIndex)"
            >
              <Icon icon="heroicons:plus-solid" class="h-4 w-4" />
              Tambah Produk
            </base-button>
          </div>
        </div>

        <div class="flex justify-end">
          <base-button @click="onAddPacket">
            <Icon icon="heroicons:plus-solid" class="h-4 w-4" />
            Tambah Koli
          </base-button>
        </div>
      </div>
    </base-card>

    <base-card title="Sisa Barang" description="Sisa barang yang belum dikemas">
      <datatable
        :columns="[
          {
            code: 'kode barang',
            name: 'Kode baranB',
          },
          {
            code: 'nama barang',
            name: 'Nama Barang',
          },
          {
            code: 'berat barang',
            name: 'Berat Barang',
          },
          {
            code: 'jumlah',
            name: 'Jumlah',
          },
        ]"
      >
        <template #tbody="{ classes }">
          <template v-if="!productsRemainder.data.length">
            <tr :class="classes.tr">
              <td colspan="4" :class="classes.td">
                <div
                  class="flex flex-col items-center space-y-2 py-4 text-center"
                >
                  <Icon
                    icon="heroicons:check-circle"
                    class="h-6 w-6 text-gray-400"
                  />
                  <p class="text-xs font-normal text-gray-400">
                    Tidak ada data barang<br />yang belum dikemas
                  </p>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="product in productsRemainder.data"
              :key="`${product.type}-${product.id}`"
              :class="classes.tr"
            >
              <td :class="classes.td">
                <p class="font-bold text-gray-900">
                  {{ product.attributes.product_code }}
                  <span v-if="product.attributes.product_type === 'free'"
                    >(PROMO)</span
                  >
                  <span v-if="product.type === 'order-detail-bonuses'"
                    >(FREE)</span
                  >
                </p>
              </td>
              <td :class="classes.td">{{ product.attributes.product_name }}</td>
              <td :class="classes.td">
                {{ product.attributes.product_weight | toFixed }}
              </td>
              <td :class="classes.td">{{ product.attributes.product_qty }}</td>
            </tr>
          </template>
        </template>
      </datatable>
    </base-card>

    <div class="flex justify-between">
      <PrintOrderSppb :order-id="order.data.id" />

      <div class="flex gap-2">
        <base-button :disabled="packed || !valid" :title="submitDisabledMessage" @click="visibleSubmit = true">
          <Icon icon="heroicons:archive-box-solid" class="h-4 w-4" />
          Siap Dikemas
        </base-button>

        <slot name="action" />
      </div>
    </div>

    <select-packet-product-modal
      :products="productsRemainder"
      :packets="packets"
      :visible="selectPacketProductModal.visible"
      :batch-mode="batchMode"
      :order-id="orderId"
      :product-boxes="productBoxes"
      :product-qr-codes="productQrCodes"
      :packet-id="selectPacketProductModal.packetId"
      @close="onCloseSelectProductModal"
      @confirmed="onConfirmedPacketProduct"
      @update-product="onUpdatePacketProduct"
    />

    <base-confirm
      @close="visibleSubmit = false"
      @confirmed="onSubmit"
      size="max-w-xl"
      :message="
        productsRemainder.data.length
          ? 'Barang yang sisa akan dimasukkan ke Susulan, apakah anda yakin akan melanjutkan?'
          : 'Apakah anda yakin data yang dibuat sudah benar?'
      "
      :type="productsRemainder.data.length ? 'warning' : 'success'"
      icon-type="badge"
      :title="
        productsRemainder.data.length ? 'Barang sisa ditemukan' : 'Buat Koli'
      "
      confirm-text="Ya"
      cancel-text="Tutup"
      :visible="visibleSubmit"
    />

    <vue-html2pdf
      v-if="order"
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="true"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="printStockMovement"
    >
      <LayoutPrintStockMovement
        slot="pdf-content"
        :stock-movement="printStockMovementAttributes"
      />
    </vue-html2pdf>
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import SelectPacketProductModal from '@/components/shipment/select-packet-product-modal.vue';
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import LayoutPrintStockMovement from '@/layouts/LayoutPrintStockMovement.vue';
import VueHtml2pdf from 'vue-html2pdf';
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import PrintOrderSppb from '../order/PrintOrderSppb.vue'
import { mapGetters } from 'vuex';

export default {
  components: {
    SelectPacketProductModal,
    BaseConfirm,
    LayoutPrintStockMovement,
    VueHtml2pdf,
    PrintOrderSppb
  },
  mixins: [requestMixin],
  props: {
    orderId: String,
    order: Object,
    loading: Boolean,
    batchMode: {
      type: String,
      default: 'input',
    },
    withExpedition: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'order',
    },
    stockMovementId: String,
    disableFollowUp: Boolean,
    packed: Boolean
  },
  emits: ['update-loading', 'submitted'],
  data() {
    return {
      orderDetails: {
        data: [],
        included: [],
        meta: {
          stock_batches: [],
        },
      },
      orderDetailBonuses: {
        data: [],
        included: [],
        meta: {
          stock_batches: [],
        },
      },
      packets: [],
      selectPacketProductModal: {
        visible: false,
        index: null,
        packetId: null,
      },
      productBoxes: [],
      productQrCodes: [],
      stockMovement: null,
      visibleSubmit: false,
      officeExpeditionId: null,
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser'
    }),
    filename() {
      const datetime = dayjs(this.order.data.attributes.createdAt).format('YYYYMMDD')
      const type = 'koli'
      const code = `${this.order.data.attributes.origin_code}_${this.order.data.attributes.destination_code}`
      const user = this.me.office_code

      return [datetime, type, code, user].join('-')
    },
    orderItems() {
      return [...this.orderDetails.data, ...this.orderDetailBonuses.data];
    },
    productsRemainder() {
      const orderDetails = this.orderDetails.data
        .map((orderDetail) => ({
          id: orderDetail.id,
          type: orderDetail.type,
          relationships: orderDetail.relationships,
          attributes: {
            ...orderDetail.attributes,
            product_qty: this.calculateProductRemainder(orderDetail),
          },
        }))
        .filter((orderDetail) => orderDetail.attributes.product_qty > 0);
      const orderDetailBonuses = this.orderDetailBonuses.data
        .map((orderDetailBonus) => ({
          id: orderDetailBonus.id,
          type: orderDetailBonus.type,
          relationships: orderDetailBonus.relationships,
          attributes: {
            ...orderDetailBonus.attributes,
            product_qty: this.calculateProductRemainder(orderDetailBonus),
          },
        }))
        .filter(
          (orderDetailBonus) => orderDetailBonus.attributes.product_qty > 0
        );

      return {
        data: [...orderDetails, ...orderDetailBonuses],
        meta: {
          stock_batches_order: this.orderDetails.meta.stock_batches,
          stock_batches_bonus: this.orderDetailBonuses.meta.stock_batches,
        },
        included: [
          ...(this.orderDetails.included ?? []),
          ...(this.orderDetailBonuses.included ?? []),
        ],
      };
    },
    printStockMovementAttributes() {
      const destinationOfficeRel =
        this.order.data.relationships['destination-office'].data;
      const destinationOffice = destinationOfficeRel
        ? this.getSingleIncluded(this.order, destinationOfficeRel.id)
        : null;
      return {
        code: this.stockMovement ? this.stockMovement.attributes.code : '-',
        date: this.stockMovement
          ? dayjs(this.stockMovement.attributes.updatedAt).format('ll LT')
          : '-',
        order: {
          code: `${this.order.data.attributes.origin_code}/${this.order.data.attributes.destination_code}`,
          destinationOffice: destinationOffice
            ? destinationOffice.attributes.code
            : '-',
          address: this.order.data.attributes.complete_shipment_address,
          structuredAddress: this.order.data.attributes.structured_complete_shipment_address,
          name:
            this.order.data.attributes.receipt_name ||
            destinationOffice.attributes.name,
          phone:
            this.order.data.attributes.receipt_phone ||
            destinationOffice.attributes.cellphone,
        },
        packets: this.packets.map((packet) => ({
          code: packet.code,
          name: packet.name,
          products: packet.products.map((product) => ({
            shipped_product_qty: product.qty,
            type: this.getProductDetail(product.orderDetailOrBonusId).type,
            product_name: this.getProductDetail(product.orderDetailOrBonusId)
              .attributes.product_name,
          })),
        })),
      };
    },
    hasFollowUp() {
      return this.productsRemainder.data.length !== 0
    },
    valid() {
      if (this.disableFollowUp) {
        return !this.hasFollowUp
      }

      return (
        this.packets.reduce(
          (total, packet) =>
            total +
            packet.products.reduce((total, product) => total + product.qty, 0),
          0
        ) > 0
      );
    },
    submitDisabledMessage() {
      if (this.packed) {
        return 'Sudah dikemas'
      }

      if (this.disableFollowUp && this.hasFollowUp) {
        return 'Tidak boleh ada susulan'
      }

      return null
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    calculateProductRemainder(product) {
      const totalPacketProductQty = this.packets.reduce((total, packet) => {
        const productMatched = packet.products.find(
          (detailProduct) => detailProduct.orderDetailOrBonusId === product.id
        );

        if (!productMatched) {
          return total;
        }

        return total + productMatched.qty;
      }, 0);

      if (product.type === 'order-detail-bonuses') {
        if (this.type === 'free_reimbursement') {
          return product.attributes.free_follow_up_remaining_qty - totalPacketProductQty
        }

        return product.attributes[this.type === 'reimbursement' ? 'reimbursement_remaining_qty' : 'bonus_remaining_qty'] - totalPacketProductQty;
      }

      return product.attributes.product_remaining_qty - totalPacketProductQty;
    },
    getProductDetail(id) {
      return this.orderItems.find((orderDetail) => orderDetail.id === id);
    },
    async loadOrderDetails() {
      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/order-details`,
        {
          params: {
            include: 'product',
            'fields[order-details]':
              'product_code,product_name,product_weight,product_not_packed,product,product_id,stock_qty,product_remaining_qty,product_type',
            'fields[products]': 'qrcode,is_qrcode_active',
            'filter[with-stock-batches]': this.batchMode === 'input',
          },
        }
      );

      if (!err) {
        this.orderDetails = res;
      }
    },
    async loadOrderDetailBonuses() {
      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/order-detail-bonuses`,
        {
          params: {
            include: 'product',
            'fields[order-detail-bonuses]':
              'product_code,product_name,product_weight,bonus_remaining_qty,reimbursement_remaining_qty,free_follow_up_remaining_qty,product,product_id',
            'fields[products]': 'qrcode,is_qrcode_active',
            'filter[with-stock-batches]': true,
            order_type: this.type
          },
        }
      );

      if (!err) {
        this.orderDetailBonuses = res;
      }
    },
    async loadOrderProductBoxes() {
      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/product-boxes`
      );

      if (!err) {
        this.productBoxes = res;
      }
    },
    async loadOrderProductQrCodes() {
      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/product-qr-codes`
      );

      if (!err) {
        this.productQrCodes = res;
      }
    },
    async loadData() {
      this.$emit('update-loading', true);

      await Promise.all([
        ...(this.type === 'order' ? [this.loadOrderDetails()] : []),
        this.loadOrderDetailBonuses(),
        ...(this.batchMode === 'input'
          ? [this.loadOrderProductBoxes(), this.loadOrderProductQrCodes()]
          : []),
      ]);

      await this.setPackets();

      this.$emit('update-loading', false);
    },
    onAddPacket() {
      const id = this.packets.length + 1;

      this.packets.push({
        id: null,
        code: `Koli ${id}`,
        name: `Koli ${id}`,
        products: [],
      });
    },
    async onAddPacketProduct(index) {
      if (this.packets[index].id) {
        this.selectPacketProductModal.index = index;
        this.selectPacketProductModal.packetId = this.packets[index].id;
        this.selectPacketProductModal.visible = true;
      } else {
        this.$emit('update-loading', true);

        const [res, err] = await this.request(`/api/v1/packets`, {
          method: 'post',
          data: {
            data: {
              type: 'packets',
              attributes: {
                code: this.packets[index].code,
                name: this.packets[index].name,
              },
              relationships: {
                'stock-movement': {
                  data: {
                    type: 'stock-movements',
                    id: this.stockMovementId,
                  },
                },
              },
            },
          },
        });

        if (!err) {
          this.packets[index].id = res.data.id;
          this.selectPacketProductModal.index = index;
          this.selectPacketProductModal.packetId = this.packets[index].id;
          this.selectPacketProductModal.visible = true;
        }

        this.$emit('update-loading', false);
      }
    },
    onConfirmedPacketProduct(products) {
      const packetProducts =
        this.packets[this.selectPacketProductModal.index].products;

      products.forEach((product) => {
        const productIndex = packetProducts.findIndex(
          (packetProduct) =>
            packetProduct.productId === product.productId &&
            packetProduct.type === product.type
        );

        if (productIndex < 0) {
          this.packets[this.selectPacketProductModal.index].products.push({
            ...product,
          });
        } else {
          const packetProduct =
            this.packets[this.selectPacketProductModal.index].products[
              productIndex
            ];

          this.packets[this.selectPacketProductModal.index].products[
            productIndex
          ].qty += product.qty;

          product.batches.forEach((batch) => {
            const batchIndex = packetProduct.batches.findIndex(
              (packetProductBatch) => packetProductBatch.id === batch.id
            );

            if (batchIndex < 0) {
              this.packets[this.selectPacketProductModal.index].products[
                productIndex
              ].batches.push({
                ...batch,
              });
            } else {
              const packetProductBatch =
                this.packets[this.selectPacketProductModal.index].products[
                  productIndex
                ].batches[batchIndex];

              this.packets[this.selectPacketProductModal.index].products[
                productIndex
              ].batches[batchIndex].qrCodes = [
                ...packetProductBatch.qrCodes,
                ...batch.qrCodes,
              ];
              this.packets[this.selectPacketProductModal.index].products[
                productIndex
              ].batches[batchIndex].qty += product.qty;
            }
          });
        }
      });

      this.selectPacketProductModal.visible = false;
    },
    onUpdatePacketProduct(product) {
      const packetProducts =
        this.packets[this.selectPacketProductModal.index].products;
      const productIndex = packetProducts.findIndex(packetProduct => {
        if (packetProduct.type === 'order-detail-bonuses') {
          return packetProduct.productId === product.productId && packetProduct.type === product.type
        }

        return packetProduct.productId === product.productId && packetProduct.type === product.type && packetProduct.orderDetailType === product.orderDetailType
      });

      if (productIndex < 0) {
        this.packets[this.selectPacketProductModal.index].products.push({
          ...product,
          qty: 0,
          dirtyQty: product.qty,
        });
      } else {
        const packetProduct =
          this.packets[this.selectPacketProductModal.index].products[
            productIndex
          ];

        this.packets[this.selectPacketProductModal.index].products[
          productIndex
        ].dirtyQty = product.qty;

        product.batches.forEach((batch) => {
          const batchIndex = packetProduct.batches.findIndex(
            (packetProductBatch) => packetProductBatch.id === batch.id
          );

          if (batchIndex < 0) {
            this.packets[this.selectPacketProductModal.index].products[
              productIndex
            ].batches.push({
              ...batch,
            });
          } else {
            const packetProductBatch =
              this.packets[this.selectPacketProductModal.index].products[
                productIndex
              ].batches[batchIndex];

            this.packets[this.selectPacketProductModal.index].products[
              productIndex
            ].batches[batchIndex].qrCodes = [
              ...packetProductBatch.qrCodes,
              ...batch.qrCodes,
            ];
            this.packets[this.selectPacketProductModal.index].products[
              productIndex
            ].batches[batchIndex].qty = batch.qty;
          }
        });
      }
    },
    onCloseSelectProductModal() {
      const packetProducts =
        this.packets[this.selectPacketProductModal.index].products;

      packetProducts.forEach((product, index) => {
        if (product.dirtyQty > 0) {
          const qty = product.dirtyQty;

          this.packets[this.selectPacketProductModal.index].products[
            index
          ].qty += qty;
          this.packets[this.selectPacketProductModal.index].products[
            index
          ].dirtyQty = 0;
        }
      });

      this.selectPacketProductModal.visible = false;
    },
    async onRemovePacket(index) {
      this.$emit('update-loading', true);

      if (this.packets[index].id) {
        const [, err] = await this.request(
          `/api/v1/packets/${this.packets[index].id}/-actions/delete`,
          {
            method: 'delete',
          }
        );

        if (err) {
          this.createAlert({
            status: 'error',
            data: this.getRequestErrorMessage(err),
            timeout: 1000,
          });
        } else {
          this.packets.splice(index, 1);
        }
      } else {
        this.packets.splice(index, 1)
      }

      this.$emit('update-loading', false);
    },
    async onRemovePacketProduct(packetIndex, index) {
      this.$emit('update-loading', true);

      const productDetail = this.packets[packetIndex].products[index];

      const [, err] = await this.request(
        `/api/v1/packets/${this.packets[packetIndex].id}/-actions/remove-movement-detail`,
        {
          method: 'post',
          data: {
            product_id: productDetail.productId,
            product_type: productDetail.type,
            order_detail_type: productDetail.orderDetailType
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
          timeout: 1000,
        });
      } else {
        this.packets[packetIndex].products.splice(index, 1);
      }

      this.$emit('update-loading', false);
    },
    async onSubmit() {
      this.$emit('update-loading', true);

      const [res, err] = await this.request(
        `/api/v1/stock-movements/${this.stockMovementId}/-actions/pack`,
        {
          method: 'post',
          data: {
            office_expedition_id: this.officeExpeditionId,
          },
        }
      );

      if (!err) {
        this.visibleSubmit = false;
        this.stockMovement = res.data;

        this.print();
      } else {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      }

      this.$emit('update-loading', false);
    },
    print() {
      setTimeout(() => {
        this.$refs.printStockMovement.generatePdf();

        const waitForEl = setInterval(() => {
          const el = document.querySelector(
            'div.vue-html2pdf > section.pdf-preview > button'
          );

          if (el) {
            el.onclick = () => this.$emit('submitted');
            clearInterval(waitForEl);
          }
        }, 100);
      }, 0);
    },
    async setPackets() {
      const [res, err] = await this.request(
        `/api/v1/stock-movements/${this.stockMovementId}/packets`,
        {
          params: {
            include: 'movement-details.batches,movement-details.product',
            'fields[packets]': 'code,name,movement-details',
            'fields[movement-details]':
              'is_bonus,product_type,product_id,shipped_product_qty,batches',
            'fields[product-batches]': 'stock_batch_id,product_qty',
          },
        }
      );

      if (!err) {
        if (res.data.length) {
          this.packets = res.data.map((packet) => {
            const movementDetails = packet.relationships[
              'movement-details'
            ].data.map((movementDetail) =>
              res.included.find((include) => include.id === movementDetail.id)
            );
            const products = movementDetails.map((movementDetail) => {
              const type =
                movementDetail.attributes.product_type === 'reguler' || movementDetail.attributes.product_type === 'promo' || !movementDetail.attributes.is_bonus
                  ? 'order-details'
                  : 'order-detail-bonuses';
              const orderDetailType = type === 'order-detail-bonuses' ? null : movementDetail.attributes.product_type === 'promo' || movementDetail.attributes.product_type === 'free' ? 'free' : 'reguler'
              const productId = movementDetail.attributes.product_id;

              const orderItem = this.orderItems.find(orderItem => {
                if (type === 'order-detail-bonuses') {
                  return orderItem.type === type && orderItem.attributes.product_id == productId
                }

                return orderItem.type === type && orderItem.attributes.product_id == productId && orderItem.attributes.product_type === orderDetailType
              });

              const batches = movementDetail.relationships[
                'batches'
              ].data.map((batch) => {
                const data = res.included.find(
                  (include) => include.id === batch.id
                );

                return {
                  id: data.attributes.stock_batch_id,
                  qrCodes: [],
                  qty: data.attributes.product_qty,
                };
              });

              return {
                orderDetailOrBonusId: orderItem.id,
                productId,
                type,
                orderDetailType,
                qty: movementDetail.attributes.shipped_product_qty,
                dirtyQty: 0,
                batches,
              };
            });

            return {
              id: packet.id,
              code: packet.attributes.code,
              name: packet.attributes.name,
              products,
            };
          });
        } else {
          this.packets = [
            {
              id: null,
              code: `Koli 1`,
              name: `Koli 1`,
              products: [],
            },
          ];
        }
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>
